'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PositionModel = require('../model/PositionModel');

var _PositionModel2 = _interopRequireDefault(_PositionModel);

var _TextControl = require('../../../lib/ui/TextControl');

var _TextControl2 = _interopRequireDefault(_TextControl);

var _PickerControl = require('../../../lib/ui/PickerControl');

var _PickerControl2 = _interopRequireDefault(_PickerControl);

var _SelectPerson = require('../../person/action/SelectPerson');

var _SelectPerson2 = _interopRequireDefault(_SelectPerson);

var _SelectLocation = require('../../location/action/SelectLocation');

var _SelectLocation2 = _interopRequireDefault(_SelectLocation);

var _PhonenumberControl = require('../../../lib/ui/PhonenumberControl');

var _PhonenumberControl2 = _interopRequireDefault(_PhonenumberControl);

var _FaxnumberControl = require('../../../lib/ui/FaxnumberControl');

var _FaxnumberControl2 = _interopRequireDefault(_FaxnumberControl);

var _EmailControl = require('../../../lib/ui/EmailControl');

var _EmailControl2 = _interopRequireDefault(_EmailControl);

var _CheckboxControl = require('../../../lib/ui/CheckboxControl');

var _CheckboxControl2 = _interopRequireDefault(_CheckboxControl);

var _DateControl = require('../../../lib/ui/DateControl');

var _DateControl2 = _interopRequireDefault(_DateControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PositionForm = function () {
  function PositionForm(element, args) {
    var _this = this;

    _classCallCheck(this, PositionForm);

    var fieldsetPosition = document.createElement('fieldset');
    var legendPosition = document.createElement('legend');
    legendPosition.innerHTML = 'Functie';
    fieldsetPosition.appendChild(legendPosition);
    var popup = null;

    this.id = args.position.values.id;
    this.person = new _PickerControl2.default(fieldsetPosition, { label: 'Persoon', value: args.position.values.person_id,
      onchange: args.onchange,
      onselect: function onselect(item) {
        if (item.values.id) {
          window.PRIM.navigate('/people/' + item.values.id);
        }
      },
      onclick: function onclick() {
        var popupElement = document.getElementById('popup');
        var viewportElement = document.getElementById('viewport');

        popup = new _SelectPerson2.default(popupElement, {
          onok: function onok(item) {
            if (item && item.values.id) {
              _this.person.setValue(item.values.id, item);
            } else {
              _this.person.setValue(null, null);
            }

            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
            _this.person.onchange();
          },
          oncancel: function oncancel() {
            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
          }
        });
        viewportElement.classList.add('invisible');
        popupElement.classList.remove('invisible');
      }
    });
    this.location = new _PickerControl2.default(fieldsetPosition, { label: 'Vestiging', value: args.position.values.location_id,
      onchange: args.onchange,
      onselect: function onselect(item) {
        if (item.values.id) {
          window.PRIM.navigate('/locations/' + item.values.id);
        }
      },
      onclick: function onclick() {
        var popupElement = document.getElementById('popup');
        var viewportElement = document.getElementById('viewport');

        popup = new _SelectLocation2.default(popupElement, {
          onok: function onok(item) {
            if (item && item.values.id) {
              _this.location.setValue(item.values.id, item);
            } else {
              _this.location.setValue(null, null);
            }

            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
            _this.person.onchange();
          },
          oncancel: function oncancel() {
            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
          }
        });
        viewportElement.classList.add('invisible');
        popupElement.classList.remove('invisible');
      }
    });
    this.title = new _TextControl2.default(fieldsetPosition, { label: 'Titel', value: args.position.values.title, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
    this.department = new _TextControl2.default(fieldsetPosition, { label: 'Afdeling', value: args.position.values.department, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
    this.start = new _DateControl2.default(fieldsetPosition, { label: 'Start', value: args.position.values.start, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
    this.end = new _DateControl2.default(fieldsetPosition, { label: 'Einde', value: args.position.values.end, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });

    var fieldsetContact = document.createElement('fieldset');
    var legendContact = document.createElement('legend');
    legendContact.innerHTML = 'Contact gegevens';
    fieldsetContact.appendChild(legendContact);

    this.phone = new _PhonenumberControl2.default(fieldsetContact, { label: 'Telefoon', value: args.position.values.phone, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
    this.mobile = new _PhonenumberControl2.default(fieldsetContact, { label: 'Mobiel', value: args.position.values.mobile, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
    this.fax = new _FaxnumberControl2.default(fieldsetContact, { label: 'Fax', value: args.position.values.fax, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
    this.email = new _EmailControl2.default(fieldsetContact, { label: 'E-mail', value: args.position.values.email, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });

    var fieldsetOptions = document.createElement('fieldset');
    var legendOptions = document.createElement('legend');
    legendOptions.innerHTML = 'Opties';
    fieldsetOptions.appendChild(legendOptions);

    this.sendchristmasemail = new _CheckboxControl2.default(fieldsetOptions, { label: 'Kerstkaart per e-mail', value: args.position.values.sendchristmasemail, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
    this.sendchristmascard = new _CheckboxControl2.default(fieldsetOptions, { label: 'Kerstkaart per post', value: args.position.values.sendchristmascard, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });

    var fragment = document.createDocumentFragment();
    fragment.appendChild(fieldsetPosition);
    fragment.appendChild(fieldsetContact);
    fragment.appendChild(fieldsetOptions);

    element.appendChild(fragment);
  }

  _createClass(PositionForm, [{
    key: 'getValue',
    value: function getValue() {
      var position = new _PositionModel2.default();
      position.person = this.person.getItem();
      position.location = this.location.getItem();
      position.values.id = this.id;
      position.values.person_id = this.person.getValue();
      position.values.location_id = this.location.getValue();
      position.values.title = this.title.getValue();
      position.values.department = this.department.getValue();
      position.values.start = this.start.getValue();
      position.values.end = this.end.getValue();
      position.values.phone = this.phone.getValue();
      position.values.mobile = this.mobile.getValue();
      position.values.fax = this.fax.getValue();
      position.values.email = this.email.getValue();
      position.values.sendchristmasemail = this.sendchristmasemail.getValue();
      position.values.sendchristmascard = this.sendchristmascard.getValue();
      return position;
    }
  }, {
    key: 'setValue',
    value: function setValue(position) {
      this.id = position.values.id;
      this.person.setValue(position.values.person_id, position.person);
      this.location.setValue(position.values.location_id, position.location);
      this.title.setValue(position.values.title);
      this.department.setValue(position.values.department);
      this.start.setValue(position.values.start);
      this.end.setValue(position.values.end);
      this.phone.setValue(position.values.phone);
      this.mobile.setValue(position.values.mobile);
      this.fax.setValue(position.values.fax);
      this.email.setValue(position.values.email);
      this.sendchristmasemail.setValue(position.values.sendchristmasemail);
      this.sendchristmascard.setValue(position.values.sendchristmascard);
    }
  }]);

  return PositionForm;
}();

exports.default = PositionForm;


//////////////////
// WEBPACK FOOTER
// ./js/modules/position/ui/PositionForm.js
// module id = 53
// module chunks = 0